import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["alt", "title", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    class: "sticker",
    alt: _ctx.alt,
    title: _ctx.alt,
    src: _ctx.stickerURL(_ctx.sticker)
  }, null, 8, _hoisted_1))
}